import { render, staticRenderFns } from "./PrintPrestador.vue?vue&type=template&id=02cfa066&scoped=true"
import script from "./PrintPrestador.vue?vue&type=script&lang=js"
export * from "./PrintPrestador.vue?vue&type=script&lang=js"
import style0 from "./PrintPrestador.vue?vue&type=style&index=0&id=02cfa066&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cfa066",
  null
  
)

export default component.exports